import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../comman/Loader";
import {baseUrl} from "../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const user_id = localStorage.getItem("userId");
    const [formData, setFormData] = useState({
        date : today,
        name : '',
        mobile_no:'',
        salary: '',
        user_id:user_id
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        name: false,
        mobile_no: false,
        salary: false
        
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();
    
    useEffect(() => {
        if(detail){
            setFormData({
                date: detail[0].date || today,
                name: detail[0].name ||0,
                mobile_no : detail[0].mobile_no || '',
                salary : detail[0].salary || 0,
                db_id: detail[0].id
            });
        }
    }, [detail]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            name : formData.name === '',
            mobile_no :!/^\d{10}$/.test(formData.mobile_no),
            salary :  formData.salary === ''
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `shop_staff/edit/${detail[0].id}`;
                }else{
                    url = "shop_staff/add";
                }
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/shop_staff/list");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        
        setFormData((prevData) => ({
            ...prevData,
            [option.name]: data,
        }));
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            
                            <div className="sm:col-span-2">
                                <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">Name</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="name"
                                      name="name"
                                      type="text"
                                      placeholder='Name'
                                      value={formData.name}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors.name ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.name && <div className="text-red-500">Please enter name.</div>}
                            </div>
                        </div>
                       
                         <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                         <div className="sm:col-span-2">
                                <label htmlFor="mobile_no" className="block text-sm font-medium leading-6 text-gray-900">Mobile No</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="mobile_no"
                                      name="mobile_no"
                                      type="number"
                                      step="0.01"
                                      placeholder='Mobile no'
                                      value={formData.mobile_no}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.mobile_no ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.mobile_no && <div className="text-red-500">Please enter mobile no.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="salary" className="block text-sm font-medium leading-6 text-gray-900">Salary</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="salary"
                                      name="salary"
                                      type="number"
                                      step="0.01"
                                      placeholder='Salary'
                                      value={formData.salary}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.salary ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.salary && <div className="text-red-500">Please enter salary.</div>}
                            </div>
                        </div>

                        
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/shop_purchase/list">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }